import { defineComponent as _defineComponent } from 'vue'
import { IFavoriteBusStop } from "@/domain/entities/favoriteBusStop";
import FavoriteStatusButton from "./FavoriteStatusButton.vue";
import { inject, PropType, ref } from "vue";
import { useFavoriteBusStop } from "@/composables/busStop/useFavoriteBusStop";
import Modal from "../shared/modal/base/Modal.vue";

import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  RouterName,
  ShowErrorModal,
} from "@/types";
import router from "@/router";
import { useRemoveFavoriteBusStop } from "@/composables/line/useRemoveFavoriteBusStop";
import { IResultData } from "@/domain/entities/shared/result";


const __default__ = {
  name: "FavoriteBusStopRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  favoriteBusStop: {
    type: Object as PropType<IFavoriteBusStop>,
    required: true,
  },
},
  emits: ["onClickRow", "onSuccessRemoveFavoriteBusStop"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const props = __props;

const emit = __emit;

const { isFavorite } = useFavoriteBusStop();
const { removeFavoriteBusStop } = useRemoveFavoriteBusStop({
  onSuccess: (result: IResultData<boolean>, busStopId: string) => {
    emit("onSuccessRemoveFavoriteBusStop", busStopId);
  },
  onError: (result: IResultData<boolean>) => {
    showErrorModal(
      "즐겨찾기 정류장 오류",
      result.errorMessage,
      result.resultCode,
      result.errorTime
    );
  },
});

const favoriteBusStopToRemove = ref();
const updateFavoriteBusStopToRemove = (busStopId: string) => {
  favoriteBusStopToRemove.value = busStopId;
};

/** 노선 정보 페이지 이동 */
const goToBusStopInfoMap = (busStopUid: string) => {
  router.push({
    name: RouterName.BusStopInfoMap,
    params: {
      busStopUid,
    },
  });
};

/** 즐겨찾기 버튼 클릭 */
const handleClickFavoriteStatusButton = async () => {
  isFavorite(props.favoriteBusStop.uid)
    ? updateFavoriteBusStopToRemove(props.favoriteBusStop.uid)
    : null; // addFavoriteBusStop
};

/** 즐겨찾기 삭제 확인 모달 ok버튼 */
const handleClickFavoriteBusStopRemoveAlertOk = async () => {
  updateFavoriteBusStopToRemove("");
  await removeFavoriteBusStop(props.favoriteBusStop.uid);
};

const __returned__ = { showErrorModal, props, emit, isFavorite, removeFavoriteBusStop, favoriteBusStopToRemove, updateFavoriteBusStopToRemove, goToBusStopInfoMap, handleClickFavoriteStatusButton, handleClickFavoriteBusStopRemoveAlertOk, FavoriteStatusButton, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})